let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5h4sF")).then(() => parcelRequire('dfboX'));